import { render, staticRenderFns } from "./recommendJob.vue?vue&type=template&id=56c6c0a2&scoped=true"
import script from "./recommendJob.vue?vue&type=script&lang=js"
export * from "./recommendJob.vue?vue&type=script&lang=js"
import style0 from "./recommendJob.vue?vue&type=style&index=0&id=56c6c0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6c0a2",
  null
  
)

export default component.exports